import { render, staticRenderFns } from "./PromAmount.vue?vue&type=template&id=74d5fa25&scoped=true"
import script from "./PromAmount.vue?vue&type=script&lang=js"
export * from "./PromAmount.vue?vue&type=script&lang=js"
import style0 from "./PromAmount.vue?vue&type=style&index=0&id=74d5fa25&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d5fa25",
  null
  
)

export default component.exports